import { defineMessages } from 'react-intl'

/* eslint no-template-curly-in-string: 0 */
export const messages = defineMessages({
  samplingRate: {
    id: 'Sampling rate {0} ({1} Sps)',
    defaultMessage: 'Sampling rate {0} ({1} Sps)',
  },
})
